var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSharelinkDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16497_169)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M7.71434 11.2715L3.12862 15.8143C2.99473 15.9471 2.88845 16.1051 2.81592 16.2792C2.74339 16.4533 2.70605 16.64 2.70605 16.8286C2.70605 17.0172 2.74339 17.2039 2.81592 17.378C2.88845 17.5521 2.99473 17.7101 3.12862 17.8429L6.1572 20.8715C6.29 21.0054 6.448 21.1117 6.62209 21.1842C6.79617 21.2567 6.98289 21.2941 7.17148 21.2941C7.36007 21.2941 7.54679 21.2567 7.72088 21.1842C7.89496 21.1117 8.05296 21.0054 8.18577 20.8715L12.7286 16.2858",
    stroke: "#007293",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M16.2858 12.7286L20.8286 8.18577C20.9625 8.05296 21.0688 7.89496 21.1413 7.72088C21.2139 7.54679 21.2512 7.36007 21.2512 7.17148C21.2512 6.98289 21.2139 6.79617 21.1413 6.62209C21.0688 6.448 20.9625 6.29 20.8286 6.1572L17.8429 3.12862C17.7101 2.99473 17.5521 2.88845 17.378 2.81592C17.2039 2.74339 17.0172 2.70605 16.8286 2.70605C16.64 2.70605 16.4533 2.74339 16.2792 2.81592C16.1051 2.88845 15.9471 2.99473 15.8143 3.12862L11.2715 7.71434",
    stroke: "#007293",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M14.8571 9.14282L9.14282 14.8571",
    stroke: "#007293",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16497_169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharelinkDesktop);
export default __webpack_public_path__ + "static/media/SharelinkDesktop.9dc9ed911e4bab92cda5712b630afe90.svg";
export { ForwardRef as ReactComponent };